<div class="pm-form">
    <form (ngSubmit)="sendReply()" novalidate [formGroup]="pmForm">
        <div class="required">Required *</div>
        <div>
            <mat-form-field class="reply-pm__title" fxFlex="90%">
                <label>
                    <input
                        matInput
                        trimInput
                        type="text"
                        placeholder="Title"
                        formControlName="title"
                    />
                </label>
                <mat-error
                    print-error
                    [control]="pmForm?.get('title')"
                    fieldName="Title"
                >
                </mat-error>
            </mat-form-field>
        </div>

        <div>
            <div class="quill-body" fxFlex="90%">
                <quill-editor
                    placeholder="Message Body *"
                    [modules]="modules"
                    [required]="true"
                    formControlName="body"
                    (onContentChanged)="setBody($event)"
                ></quill-editor>
                <mat-error
                    print-error
                    [control]="pmForm?.get('body')"
                    fieldName="Message Body"
                >
                </mat-error>
            </div>
        </div>

        <mat-action-row>
            <div fxLayout="row" fxLayoutAlign="end" fxFill fxFlex="100">
                <button
                    mat-raised-button
                    color="secondary"
                    type="button"
                    (click)="onClickCancel()"
                >
                    <mat-icon aria-label="Cancel">close</mat-icon>
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    type="submit"
                    class="wide-button"
                    [disabled]="pmForm?.invalid || working"
                >
                    <mat-icon aria-label="Send">send</mat-icon>
                </button>
            </div>
        </mat-action-row>
    </form>
</div>
